import { getTrackStatusUpdates } from "@/modules/property-track-settings/api";
import { TrackStatusUpdatesDto } from "@/modules/property-track-settings/types";
import { useQuery } from "@tanstack/react-query";

export const useGetTrackStatusUpdates = (trackUid?: string) => {
  const query = useQuery({
    queryKey: ["track-status-updates", trackUid],
    queryFn: () => {
      if (!trackUid) return undefined;
      return getTrackStatusUpdates(trackUid);
    },
    enabled: !!trackUid,
  });
  const stagesPrecedencesHistory = query.data?.data
    ?.flatMap((item: TrackStatusUpdatesDto) => [
      item?.oldStage?.precedence,
      item?.newStage?.precedence,
    ])
    .filter((p): p is number => typeof p === "number");
  return {
    ...query,
    data: query.data?.data,
    stagesPrecedencesHistory: [...new Set(stagesPrecedencesHistory)],
  };
};
